/**
 * 装配体引用复制元数据类型。
 *
 * 设计说明：
 * 1. 装配体复制只创建新的 occurrence，不复制源零件或子装配的几何 payload；
 * 2. 该枚举用于持久化有限复制语义，避免用散落字符串判断保存/导入行为；
 * 3. 后续若支持镜像复制、阵列派生复制，可继续扩展枚举而不破坏现有引用复制。
 */
export enum AssemblyReferenceCopyKind {
  /** 当前节点是通过复制已有装配 occurrence 得到的引用 occurrence。 */
  ReferenceOccurrence = 'reference-occurrence',
}

//------ 装配体引用复制族 开始------
/**
 * 装配体引用复制族成员角色。
 */
export enum AssemblyReferenceCopyLineageRole {
  /** 原始 occurrence；它导出完整几何 payload，不会被当成引用复制体跳过。 */
  OriginOccurrence = 'origin-occurrence',
  /** 引用复制 occurrence；默认只保存引用关系，位置由装配节点 transform 统一承载。 */
  ReferenceOccurrence = 'reference-occurrence',
}

/**
 * 装配体引用复制族元数据。
 */
export interface AssemblyReferenceCopyLineageMetadata {
  /** 引用复制族 ID；同源的 A / A_1 / A_2 必须共享该 ID。 */
  readonly referenceFamilyId: string;
  /** 稳定定义 ID；优先使用零件或子装配 UUID，用于源 occurrence 删除后的恢复。 */
  readonly definitionId: string;
  /** 最早参与复制的原始 occurrence ID。 */
  readonly originOccurrenceId: string;
  /** 当前成员角色。 */
  readonly role: AssemblyReferenceCopyLineageRole;
  /** 当前 occurrence 直接复制自哪个 occurrence。 */
  readonly copiedFromOccurrenceId?: string;
}
//------ 装配体引用复制族 结束------

/**
 * 装配体引用复制可序列化元数据。
 */
export interface AssemblyReferenceCopyMetadata {
  /** 引用复制类型。 */
  readonly kind: AssemblyReferenceCopyKind;
  /** 被复制的源装配节点 ID。 */
  readonly sourceNodeId: string;
  /** 被复制的源零件或子装配文件 UUID；缺失时按源节点继续回退。 */
  readonly sourcePartFileUuid?: string;
  /** 源组件实例 ID；用于历史回放或诊断定位运行时源对象。 */
  readonly sourceComponentInstanceId?: string;
  /** 复制体父装配节点 ID。 */
  readonly parentNodeId?: string;
  //------ 装配体引用复制族 开始------
  /** 引用复制族 ID；同源复制体共享该 ID。 */
  readonly referenceFamilyId?: string;
  /** 稳定定义 ID；用于源 occurrence 被删除后仍可按定义恢复复制体。 */
  readonly definitionId?: string;
  /** 最早参与复制的原始 occurrence ID。 */
  readonly originOccurrenceId?: string;
  /** 当前 occurrence 直接复制自哪个 occurrence。 */
  readonly copiedFromOccurrenceId?: string;
  //------ 装配体引用复制族 结束------
}
